<script>
    import { onMount } from 'svelte';
    import { fly } from 'svelte/transition';
    import { key } from '../store';
    import Player from './Player.svelte';

	let storedKey;
	key.subscribe((newValue) => storedKey = newValue);

    let folders;
    let playedVideo;
    let playedFolder;

    function fetchVideos () {
        fetch(`${_app.env.API_URL}/videos?key=${storedKey}`).then((res) => {
            res.json().then((data) => {
                console.log(data);
                folders = data;
            });
        }).catch(() => {
            key.set(null);
        });
    }

    function play(folder, video) {
        playedVideo = video;
        playedFolder = folder;
    }
    function dl(folder, video) {
        window.open(`${_app.env.API_URL}/download?video=${folder}/${video}&key=${storedKey}`);
    }
    
    onMount(() => fetchVideos());
</script>

<div class="app-container" transition:fly="{{ y: 200, duration: 1000 }}">
    <div>
        <h1>Bienvenue sur Stream</h1>
        {#if !folders}
            <h3>Loading...</h3>
        {:else}
            <h2 class="videos-title">Made with ❤️ by Simon ;)</h2>
            <div class="videos-galery">
                {#each folders as folder}
                    <h2>{folder.name}</h2>
                    <div class="folder-item">
                        {#each folder.videos as video}
                            <div class="video-item">
                                <h3 class="video-title">{video}</h3>
                                <div class="video-item-controls">
                                    <div on:click={play(folder.name, video)}><svg class="video-item-icon-play" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></div>
                                    <div on:click={dl(folder.name, video)}><svg class="video-item-icon-dl" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg></div>
                                </div>
                            </div>
                        {/each}
                    </div>
                {/each}
            </div>
        {/if}
        {#if playedVideo}
            <h2 class="player-title">Player</h2>
            <p class="player-title">Cliquez sur le player pour passer en mode plein écran !</p>
            <div class="player-content">
                <div><Player name={`${playedFolder}/${playedVideo}`} key={storedKey} /></div>
            </div>
        {/if}
    </div>
</div>

<style>
    .videos-title {
        color: #FFD151;
    }
    .video-title {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    h1, .videos-title, .player-title, .player-content {
    	text-align: center;
    }
    .app-container {
        height: 100%;
        width: 90%;
    }
    .folder-item {
        display: grid;
        row-gap: 10px;
    }
    .video-item {
        padding: 0.3rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: 1px solid #FFD151;
        border-radius: 10px;
    }
    .videos-galery {
        margin: 10px;
    }
    .video-item-controls {
        display: flex;
    }
    .video-item-icon-play {
        width: 40px;
        margin: 10px 0px 10px 10px;
        color: orange;
        cursor: pointer;
    }
    .video-item-icon-dl {
        width: 40px;
        margin: 10px 0px 10px 10px;
        color: orange;
        cursor: pointer;
    }
    @media (min-width: 1080px) {
        .folder-item {
            grid-template-columns: repeat(4, 1fr);
            column-gap: 10px;
        }
    }
</style>